import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {Invoice} from "./invoice";
import {catchError} from "rxjs/operators";
import {InvoiceFormComponent} from "./invoice-form/invoice-form.component";
import {Customer} from "./customer";
import {CustomerFormComponent} from "./customer-form/customer-form.component";
import {InvoiceListComponent} from "./invoice-list/invoice-list.component";

@Injectable()
export class InvoiceService {

  private invoicesUrl: string;

  constructor(private http: HttpClient) {
    this.invoicesUrl = window.location.protocol + "//" + window.location.hostname + "/invoices";
  }

  public findAll(): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(this.invoicesUrl);
  }

  public findById(id: string): Observable<Invoice> {
    return this.http.get<Invoice>(this.invoicesUrl + '/' + id);
  }

  public findAllByCustomerId(id2: string): Observable<Invoice[]> {
    return this.http.get<Invoice[]>(this.invoicesUrl + '/customer/' + id2);
  }

  public delete(id: string) {
    return this.http.delete(this.invoicesUrl + '/' + id);
  }

  public save(invoice: Invoice, form: InvoiceFormComponent) {
    return this.http.post<Invoice>(this.invoicesUrl, invoice).pipe(catchError((error: HttpErrorResponse) => {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        errorMessage = `${error.error.message}`;
      } else {
        errorMessage = `${error.error} (status: ${error.status})\n`;
      }
      form.myError = errorMessage;
      //window.alert(errorMessage);
      return undefined;
    }));
  }

  public update(invoice: Invoice, form: InvoiceFormComponent) {
    return this.http.put(this.invoicesUrl, invoice).pipe(catchError((error: HttpErrorResponse) => {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        errorMessage = `${error.error.message}`;
      } else {
        errorMessage = `${error.error} (status: ${error.status})\n`;
      }
      form.myError = errorMessage;
      //window.alert(errorMessage);
      return undefined;
    }));
  }

  public pay(id: string) {
    return this.http.patch(this.invoicesUrl + '/' + id, null);
  }

}



// WEBPACK FOOTER //
// ./src/app/invoice-service.service.ts